import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { Button } from 'common/components/Buttons/Button.tsx';
import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useExternalRowSelectionApi } from 'common/components/ConfigurableTable/Components/Rows/ExternalRowSelection/hooks/useExternalRowSelectionApi.tsx';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(10),
}));

const AlertInfoContainer = styled(Box)<{ enabled?: boolean }>(({ theme, enabled = false }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(10),
  opacity: enabled ? 1 : 0.4,

  '& > .MuiTypography-root > .MuiTypography-root': {
    fontWeight: enabled ? '600' : 400,
  },
}));

type ActionsToolbarProps = {
  children: React.ReactNode;
};

export const ActionsToolbar = ({ children }: ActionsToolbarProps) => {
  const { t } = useTranslation();

  const { selectedIds, unSelectAll } = useExternalRowSelectionApi();

  const selectedTariffIds = Array.from(selectedIds) as string[];
  const numberOfSelectedRows = selectedTariffIds.length;

  return (
    <Container>
      {children}
      <AlertInfoContainer enabled={!!numberOfSelectedRows}>
        <Divider orientation="vertical" sx={{ height: '1rem' }} />
        <Typography variant="body2" data-testid="numberOfSelectedTariffs">
          <Typography component="span">{numberOfSelectedRows}</Typography> {t('common.selected')}
        </Typography>
      </AlertInfoContainer>
      {!!numberOfSelectedRows && (
        <Button
          onClick={() => unSelectAll()}
          disabled={!numberOfSelectedRows}
          size="medium"
          aria-label="Clear selection"
          variant="tertiary"
        >
          {t('tariffSummary.table.usageAlert.clearSelection')}
        </Button>
      )}
    </Container>
  );
};
